import {match} from 'ts-pattern';

import {BusinessCaseType} from '@dms/api/sales';

import {Nullish} from 'shared/web';

export type TradeInCreateMode = 'create-vehicle' | 'select-vehicle';

export interface TradeInConfig {
  hostType: 'SELLING' | 'BUYING';
  gridCode: 'trade-in-buying-counterpart' | 'trade-in-selling-counterpart';
  createMode: TradeInCreateMode;
  createVehicleField: 'vehicleToPurchaseId' | 'vehicleToSaleId';
  linkExistingLabelKey: string;
  createNewLabelKey: string;
}

const SELLING_CONFIG: TradeInConfig = {
  hostType: 'SELLING',
  gridCode: 'trade-in-buying-counterpart',
  createMode: 'create-vehicle',
  createVehicleField: 'vehicleToPurchaseId',
  linkExistingLabelKey: 'page.businessCase.tradeIn.linkExistingBuying',
  createNewLabelKey: 'page.businessCase.tradeIn.createNewBuying',
};

const BUYING_CONFIG: TradeInConfig = {
  hostType: 'BUYING',
  gridCode: 'trade-in-selling-counterpart',
  createMode: 'select-vehicle',
  createVehicleField: 'vehicleToSaleId',
  linkExistingLabelKey: 'page.businessCase.tradeIn.linkExistingSelling',
  createNewLabelKey: 'page.businessCase.tradeIn.createNewSelling',
};

export const getTradeInConfig = (hostType: BusinessCaseType | Nullish): TradeInConfig | null =>
  match(hostType)
    .with('SELLING', () => SELLING_CONFIG)
    .with('BUYING', () => BUYING_CONFIG)
    .otherwise(() => null);
